import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiRoutesService } from '../api-routes.service';
import { Language } from '../../models/translation/language.model';
import { LocaleLanguage } from '../../models/translation/locale-language.model';
import { AuthenticationService } from '../authentication.service';
import {MemberService} from '../member.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  readonly #LANGUAGE_CODE_KEY = 'language';

  readonly #authentService: AuthenticationService = inject(AuthenticationService);
  readonly #memberService: MemberService = inject(MemberService);
  readonly #httpClient = inject(HttpClient);
  readonly #routes = inject(ApiRoutesService);
  readonly #navigator = window.navigator;

  public findAllLanguages(): Observable<Language[]> {
    return this.#httpClient.get<Language[]>(this.#routes.languages());
  }

  public findAllLanguageCodes(): Observable<LocaleLanguage[]> {
    return this.#httpClient.get<LocaleLanguage[]>(this.#routes.languageCodes());
  }

  getLanguage(key: string) {
    return this.#httpClient.get<Language>(this.#routes.language(key));
  }

  createLanguage(key: string, name: string, displayName: string): Observable<Language> {
    return this.#httpClient.post<Language>(this.#routes.languages(), {key, name, displayName});
  }

  private getNavigatorGenericLanguage() {
    const localStoredLanguage = localStorage.getItem(this.#LANGUAGE_CODE_KEY);

    if (localStoredLanguage) {
      return localStoredLanguage;
    }

    let currentLanguage = this.#navigator.language;
    currentLanguage = currentLanguage.replaceAll('_', '-');

    return currentLanguage.split('-')[0].trim();
  }

  getPreferredLanguageCode() {
    return this.#authentService.member?.profile?.preferredLanguageKey != null ?
      this.#authentService.member.profile.preferredLanguageKey :
      this.getNavigatorGenericLanguage();
  }

  changeLanguage(code: string) {
    if(this.#authentService.isAuthenticated) {
      this.#memberService.updateMe({languageKey: code}).subscribe();
    }else{
      localStorage.setItem(this.#LANGUAGE_CODE_KEY, code);
    }
    window.location.reload();
  }
}
